import { circInOut } from './basler-components.es830.js';
import { backInOut } from './basler-components.es826.js';
import { anticipate } from './basler-components.es825.js';

const unsupportedEasingFunctions = {
    anticipate,
    backInOut,
    circInOut,
};
function isUnsupportedEase(key) {
    return key in unsupportedEasingFunctions;
}
function replaceStringEasing(transition) {
    if (typeof transition.ease === "string" &&
        isUnsupportedEase(transition.ease)) {
        transition.ease = unsupportedEasingFunctions[transition.ease];
    }
}

export { replaceStringEasing };
